const DEFAULT_COMMERCIAL_PATH = '/commercial/tableau-de-bord';

/** Only resume a local commercial page, never the login form or an external URL. */
export function commercialLoginTarget(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(next)) return DEFAULT_COMMERCIAL_PATH;
  try {
    const url = new URL(next, 'https://commercial.invalid');
    const pathname = decodeURIComponent(url.pathname);
    if (url.origin !== 'https://commercial.invalid' || !pathname.startsWith('/commercial/') || /^\/commercial\/login(?:\/|$)/.test(pathname) || pathname.includes('\\')) return DEFAULT_COMMERCIAL_PATH;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return DEFAULT_COMMERCIAL_PATH;
  }
}

/** Bound both session checks and role lookups; late responses cannot resume the UI. */
export function withCommercialLoginTimeout<T>(operation: PromiseLike<T>, ms = 15000): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('LOGIN_TIMEOUT')), ms);
    Promise.resolve(operation).then(
      value => { clearTimeout(timer); resolve(value); },
      error => { clearTimeout(timer); reject(error); },
    );
  });
}
